import React from "react";
import { Route, Switch, Redirect } from "react-router";

import { EventsRelocation } from "./relocation";
import { EventsMajority } from "./majority";
import { EventsMarriage } from "./marriage";
import { EventsBirth } from "./birth";
import { EventsDivorce } from "./divorce";

import { Header } from "./_common/header";

export const Events = () => {
	return (
		<article className="view-calc pt-3 pt-gd-sm mb-auto pb-sm">
			<h1 className="sr-only visually-hidden">Events</h1>
			<Header />
			<Switch>
				<Route exact path="/anticipa/events" component={EventsRelocation} />
				<Route path="/anticipa/events/majority" component={EventsMajority} />
				<Route path="/anticipa/events/relocation" component={EventsRelocation} />
				<Route path="/anticipa/events/marriage" component={EventsMarriage} />
				<Route path="/anticipa/events/birth" component={EventsBirth} />
				<Route path="/anticipa/events/divorce" component={EventsDivorce} />

				<Route
					render={() => {
						return <Redirect exact to="/anticipa/events" />;
					}}
				/>
			</Switch>
		</article>
	);
};
